import React from 'react';
import PropTypes from 'prop-types';
import AvailabilityItem from './AvailabilityItem';
import * as Styled from './Availability.styles';

var Availability = function Availability(_ref) {
  var _availability$collect, _availability$deliver;

  var availability = _ref.availability;
  return /*#__PURE__*/React.createElement(React.Fragment, null, ((availability === null || availability === void 0 ? void 0 : availability.collection) || (availability === null || availability === void 0 ? void 0 : availability.delivery)) && /*#__PURE__*/React.createElement(Styled.AvailabilityList, null, /*#__PURE__*/React.createElement(AvailabilityItem, {
    fulfillmentLabel: "Collection",
    available: availability === null || availability === void 0 ? void 0 : (_availability$collect = availability.collection) === null || _availability$collect === void 0 ? void 0 : _availability$collect.available
  }), /*#__PURE__*/React.createElement(AvailabilityItem, {
    fulfillmentLabel: "Delivery",
    available: availability === null || availability === void 0 ? void 0 : (_availability$deliver = availability.delivery) === null || _availability$deliver === void 0 ? void 0 : _availability$deliver.available
  })));
};

Availability.propTypes = {
  availability: PropTypes.shape({
    collection: {
      available: PropTypes.bool
    },
    delivery: {
      available: PropTypes.bool
    }
  })
};
export default Availability;